import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "page-container",
  id: "team-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-44" }, null, -1)
const _hoisted_3 = { class: "flex flex-col items-center justify-center sm:mb-32" }
const _hoisted_4 = { class: "sm:flex sm:flex-wrap max-w-7xl relative" }
const _hoisted_5 = { class: "w-full aspect-[9/12] mb-5" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex justify-between gap-10" }
const _hoisted_8 = { class: "font2 text-2xl" }
const _hoisted_9 = { class: "font1 text-sm" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" })
], -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.teamMembers, (teamMember) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "sm:basis-1/2 md:basis-1/3 p-5 ani-top",
            key: teamMember.id
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "object-cover w-full h-full",
                src: teamMember.img
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createElementVNode("h1", _hoisted_8, _toDisplayString(teamMember.name), 1),
                _createElementVNode("h2", _hoisted_9, _toDisplayString(teamMember.position), 1)
              ]),
              (teamMember.linkedinurl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("a", {
                      target: "_blank",
                      href: teamMember.linkedinurl,
                      class: "transition hover:opacity-50"
                    }, _hoisted_13, 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}